export default function (http) {
    return {

        saveInfo(data) {
            return http.json({
                url: `/sku/reg/base/save`,
                data
            })
        },

        updateBase(data) {
            return http.json({
                url: `/sku/reg/base/updateBase`,
                data
            })
        },

        getBase(data) {
            return http.json({
                url: `/sku/reg/base/getBase`,
                data
            })
        },
        getInfo(data) {
            return http.json({
                url: `/sku/reg/base/get?id=${data.id}`,
                data
            })
        },
        updateState(data) {
            return http.json({
                url: `/sku/reg/base/updateState`,
                data
            })
        },
        queryLog(data) {
            return http.json({
                url: `/sku/declare/queryAll`,
                data
            })
        },

        queryByPage (data){
            return http.json({
                url: '/sku/reg/base/query',
                data
            });
        },

        queryOldByPage (data){
            return http.json({
                url: '/sku/oldRegBase/query',
                data
            });
        },

        getOldInfo(data) {
            return http.json({
                url: `/sku/oldRegBase/get?id=${data.id}`,
                data
            })
        },

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/skuRegBase.js